var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mr-1 nowrap",class:{'frequency-button--disabled' : _vm.disabled},attrs:{"icon":"","small":"","elevation":_vm.disabled ? 0: 1,"color":_vm.active ? 'primary' : 'gray'},on:{"click":_vm.select}},[(_vm.active)?_c('v-icon',[_vm._v(" mdi-briefcase-variant ")]):_c('v-icon',[_vm._v(" mdi-briefcase-variant-outline ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }